class WithdrawalFunction extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;
    this.stepOne = this.querySelector('[data-withdrawal-step="1"]');
    this.stepTwo = this.querySelector('[data-withdrawal-step="2"]');
    this.summary = this.querySelector('[data-withdrawal-summary]');
    this.bodyField = this.querySelector('[data-withdrawal-body]');
    this.timestampField = this.querySelector('[data-withdrawal-timestamp]');
    this.querySelector('[data-withdrawal-continue]')?.addEventListener('click', () => this.review());
    this.querySelector('[data-withdrawal-back]')?.addEventListener('click', () => this.back());
    this.querySelector('[data-withdrawal-print]')?.addEventListener('click', () => window.print());
    this.form.addEventListener('submit', (event) => this.prepareSubmit(event));
  }
  value(name) { return (this.form.elements[name]?.value || '').trim(); }
  labels() { try { return JSON.parse(this.dataset.labels || '{}'); } catch { return {}; } }
  buildReceipt() {
    const l = this.labels();
    const scope = this.form.querySelector('input[name="withdrawal_scope"]:checked')?.value || 'full';
    const lines = [l.declaration, '', `${l.name}: ${this.value('contact[name]')}`, `${l.email}: ${this.value('contact[email]')}`, `${l.order}: ${this.value('contact[order_number]')}`, `${l.scope}: ${scope === 'partial' ? l.partial : l.full}`];
    if (scope === 'partial') lines.push(`${l.items}: ${this.value('contact[items]')}`);
    const note = this.value('contact[note]');
    if (note) lines.push(`${l.note}: ${note}`);
    lines.push(`${l.received}: ${new Date().toLocaleString(document.documentElement.lang || undefined)}`);
    return lines.join('\n');
  }
  review() {
    const partial = this.form.querySelector('input[name="withdrawal_scope"]:checked')?.value === 'partial';
    const items = this.form.elements['contact[items]'];
    if (items) items.required = partial;
    if (!this.form.reportValidity()) return;
    const receipt = this.buildReceipt();
    this.summary.textContent = receipt;
    this.bodyField.value = receipt;
    this.timestampField.value = new Date().toISOString();
    this.stepOne.hidden = true;
    this.stepTwo.hidden = false;
    this.stepTwo.querySelector('button')?.focus();
    this.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  back() { this.stepTwo.hidden = true; this.stepOne.hidden = false; this.stepOne.querySelector('input')?.focus(); }
  prepareSubmit(event) {
    if (this.stepTwo.hidden) { event.preventDefault(); this.review(); return; }
    this.bodyField.value = this.buildReceipt();
    this.timestampField.value = new Date().toISOString();
  }
}
if (!customElements.get('withdrawal-function')) customElements.define('withdrawal-function', WithdrawalFunction);
